global.emptyOidArgusInput = () => {
    $('#oid-argus-reset').on('click', () => {
        $('#oidArgusInput').val(null);
        $('#vehicle_folder_vehicleQuotation_oidArgus').val(null);
    })
}

global.emptyInfoCG = () => {
    $('#info-cg-reset').on('click', () => {
        $('#vehicle_folder_registrationDocument_immatriculation').val(null);
        $('#vehicle_folder_vehicleQuotation_typeVh').val(null).change();
        $('#vehicle_folder_vehicleQuotation_marque').val(null).change();
        $('#vehicle_folder_vehicleQuotation_dateDePmec').val(null).change();
        $('#vehicle_folder_vehicleQuotation_anneeMillesime').val(null).change();
        $('#vehicle_folder_vehicleQuotation_energie').val(null).change();
        $('#vehicle_folder_vehicleQuotation_puissance').val(null).change();
        $('#vehicle_folder_vehicleQuotation_places').val(null).change();
        $('#vehicle_folder_vehicleQuotation_carrosserie').val(null).change();
        $('#vehicle_folder_vehicleQuotation_typeMine').val(null).change();
        $('#vehicle_folder_vehicleQuotation_numeroDeSerie').val(null).change();
        $('#vehicle_folder_vehicleQuotation_typeCommercial').val(null).change();
        $('#vehicle_folder_vehicleQuotation_couleur').val(null).change();
        $('#vehicle_folder_administration_datecert').val(null);
        $('#vehicle_folder_vehicleQuotation_regroupement').val(null).change();
        $('#vehicle_folder_vehicleQuotation_co2').val(null).change();
        $('#vehicle_folder_vehicleQuotation_genreArgus').val(null).change();
        $('#vehicle_folder_vehicleQuotation_date1mecArgus').val(null).change();
    })
}

global.handleBmwEquipment = (path) => {
    $('#bmw-equipment-modal-button').on('click', () => {
        // If there isn't a table as a child of #bmw-equipment, the Ajax request was never made, so JUST DO IT.
        if ($('#bmw-equipment').find('table').length === 0) {
            $.ajax({
                method: 'POST',
                url: path,
                success: html => {
                    $('#bmw-equipment').children().replaceWith(html);
                },
            });
        }
    });
}

global.handlePartlyCarBody = (path, partlyCarBodyDetails, segment, typeVh) => {
    $('.partly-car-body-modal-button').on('click', () => {
        // If there isn't a table as a child of #partly-car-body-detail, the Ajax request was never made, so JUST DO IT.
        if ($('#partly-car-body-detail').find('ul').length === 0) {
            $.ajax({
                method: 'POST',
                url: path,
                data: {
                    'partly_car_body_details': partlyCarBodyDetails,
                    'segment': segment,
                    'vehicle_type': typeVh,
                },
                success: html => {
                    $('#partly-car-body-detail').html(html);
                    $('#partly-car-body-loader').addClass('d-none');
                },
            });
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/folder.js